// Imports: local files.
import ApiClient from '../../services/ApiClient';
import { showSnackbar, dispatchLoading, dispatchSuccess, dispatchError, getAxiosError } from '../../utils/redux';

// Name of property to be used in reducer data.
const techniquesName = 'techniques';
const techniqueName = 'technique';

// Action Types: Get All Techniques.
export const GET_TECHNIQUES_START = 'GET_TECHNIQUES_START';
export const GET_TECHNIQUES_SUCCESS = 'GET_TECHNIQUES_SUCCESS';
export const GET_TECHNIQUES_FAILED = 'GET_TECHNIQUES_FAILED';
export const GET_TECHNIQUES_RESET = 'GET_TECHNIQUES_RESET';

// Action Types: Get One Technique.
export const GET_TECHNIQUE_START = 'GET_TECHNIQUE_START';
export const GET_TECHNIQUE_SUCCESS = 'GET_TECHNIQUE_SUCCESS';
export const GET_TECHNIQUE_FAILED = 'GET_TECHNIQUE_FAILED';
export const GET_TECHNIQUE_RESET = 'GET_TECHNIQUE_RESET';

// Action Types: Create Technique.
export const CREATE_TECHNIQUE_START = 'CREATE_TECHNIQUE_START';
export const CREATE_TECHNIQUE_SUCCESS = 'CREATE_TECHNIQUE_SUCCESS';
export const CREATE_TECHNIQUE_FAILED = 'CREATE_TECHNIQUE_FAILED';
export const CREATE_TECHNIQUE_RESET = 'CREATE_TECHNIQUE_RESET';

// Action Types: Update Technique.
export const UPDATE_TECHNIQUE_START = 'UPDATE_TECHNIQUE_START';
export const UPDATE_TECHNIQUE_SUCCESS = 'UPDATE_TECHNIQUE_SUCCESS';
export const UPDATE_TECHNIQUE_FAILED = 'UPDATE_TECHNIQUE_FAILED';
export const UPDATE_TECHNIQUE_RESET = 'UPDATE_TECHNIQUE_RESET';

// Action Types: Delete Technique.
export const DELETE_TECHNIQUE_START = 'DELETE_TECHNIQUE_START';
export const DELETE_TECHNIQUE_SUCCESS = 'DELETE_TECHNIQUE_SUCCESS';
export const DELETE_TECHNIQUE_FAILED = 'DELETE_TECHNIQUE_FAILED';
export const DELETE_TECHNIQUE_RESET = 'DELETE_TECHNIQUE_RESET';

// Action Creators: Get All Techniques.
const getTechniquesStart = (payload) => ({ type: GET_TECHNIQUES_START, payload });
const getTechniquesSuccess = (payload) => ({ type: GET_TECHNIQUES_SUCCESS, payload });
const getTechniquesFailed = (payload) => ({ type: GET_TECHNIQUES_FAILED, payload });
const getTechniquesReset = () => ({ type: GET_TECHNIQUES_RESET });

// Action Creators: Get One Technique.
const getTechniqueStart = (payload) => ({ type: GET_TECHNIQUE_START, payload });
const getTechniqueSuccess = (payload) => ({ type: GET_TECHNIQUE_SUCCESS, payload });
const getTechniqueFailed = (payload) => ({ type: GET_TECHNIQUE_FAILED, payload });
const getTechniqueReset = () => ({ type: GET_TECHNIQUE_RESET });

// Action Creators: Create Technique.
const createTechniqueStart = (payload) => ({ type: CREATE_TECHNIQUE_START, payload });
const createTechniqueSuccess = (payload) => ({ type: CREATE_TECHNIQUE_SUCCESS, payload });
const createTechniqueFailed = (payload) => ({ type: CREATE_TECHNIQUE_FAILED, payload });
const createTechniqueReset = () => ({ type: CREATE_TECHNIQUE_RESET });

// Action Creators: Update Technique.
const updateTechniqueStart = (payload) => ({ type: UPDATE_TECHNIQUE_START, payload });
const updateTechniqueSuccess = (payload) => ({ type: UPDATE_TECHNIQUE_SUCCESS, payload });
const updateTechniqueFailed = (payload) => ({ type: UPDATE_TECHNIQUE_FAILED, payload });
const updateTechniqueReset = () => ({ type: UPDATE_TECHNIQUE_RESET });

// Action Creators: Delete Technique.
const deleteTechniqueStart = (payload) => ({ type: DELETE_TECHNIQUE_START, payload });
const deleteTechniqueSuccess = (payload) => ({ type: DELETE_TECHNIQUE_SUCCESS, payload });
const deleteTechniqueFailed = (payload) => ({ type: DELETE_TECHNIQUE_FAILED, payload });
const deleteTechniqueReset = () => ({ type: DELETE_TECHNIQUE_RESET });

// Actions: Get All Techniques.
export const getTechniques = (payload, options = {}) => {
  const { page, limit, pagination, name } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getTechniquesStart);

      const query = { page, limit, pagination, name };
      const result = await ApiClient.get('/techniques', { params: query });
      if (result.data?.success) {
        const { techniques } = result.data?.data;
        dispatchSuccess(dispatch, getTechniquesSuccess, techniques, techniquesName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getTechniquesFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getTechniquesFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get All Techniques.
export const clearTechniques = () => getTechniquesReset();

// Actions: Get One Technique.
export const getTechnique = (payload, options = {}) => {
  const { techniqueId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getTechniqueStart);

      const result = await ApiClient.get(`/techniques/${techniqueId}`);
      if (result.data?.success) {
        const { technique } = result.data?.data;
        dispatchSuccess(dispatch, getTechniqueSuccess, technique, techniqueName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getTechniqueFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getTechniqueFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get One Technique.
export const clearTechnique = () => getTechniqueReset();

// Actions: Create Technique.
export const createTechnique = (payload, options = {}) => {
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, createTechniqueStart);

      const fields = ['name', 'description', 'achronym', 'informationLinks', 'photo'];

      const formData = new FormData();
      fields.forEach((field) => payload[field] && formData.append(field, payload[field]));

      const result = await ApiClient.post(`/techniques`, formData);
      if (result.data?.success) {
        const { technique } = result.data?.data;
        dispatchSuccess(dispatch, createTechniqueSuccess, technique, techniqueName);
        showSnackbar(dispatch, 'Technique created succesfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, createTechniqueFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, createTechniqueFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Created Technique.
export const clearCreatedTechnique = () => createTechniqueReset();

// Actions: Update Technique.
export const updateTechnique = (payload, options = {}) => {
  const { techniqueId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, updateTechniqueStart);

      const fields = ['name', 'description', 'achronym', 'informationLinks', 'photo'];

      const formData = new FormData();
      fields.forEach((field) => payload[field] && formData.append(field, payload[field]));

      const result = await ApiClient.put(`/techniques/${techniqueId}`, formData);
      if (result.data?.success) {
        const { technique } = result.data?.data;
        dispatchSuccess(dispatch, updateTechniqueSuccess, technique, techniqueName);
        showSnackbar(dispatch, 'Technique updated successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, updateTechniqueFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, updateTechniqueFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Updated Technique.
export const clearUpdatedTechnique = () => updateTechniqueReset();

// Actions: Delete Technique.
export const deleteTechnique = (payload, options = {}) => {
  const { techniqueId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, deleteTechniqueStart);

      const result = await ApiClient.delete(`/techniques/${techniqueId}`);
      if (result.data?.success) {
        const { technique } = result.data?.data;
        dispatchSuccess(dispatch, deleteTechniqueSuccess, technique, techniqueName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, deleteTechniqueFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, deleteTechniqueFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Deleted Technique.
export const clearDeletedTechnique = () => deleteTechniqueReset();
